module.exports = __webpack_public_path__ + "static/media/import-listing-icon.f724bc44.svg";